import PropTypes from 'prop-types';

// Components
import Tooltip from '@/components/base/Tooltip';
import { Trans } from '@/components/tools/translation';

export const TooltipDisableSortableItem = ({
    activeFilter,
    resetFilters = () => {
        /** */
    },
    children
}) => {
    if (activeFilter && activeFilter?.value !== 'all') {
        return (
            <Tooltip
                interactive={true}
                position="top"
                popperOptions={{
                    strategy: 'fixed'
                }}
                content={
                    <Trans
                        i18nKey="scheduler:feed.reset_filters_disable"
                        components={{
                            tag0: (
                                <button
                                    className="ml-0.5 text-icoBlue underline"
                                    onClick={resetFilters}
                                />
                            )
                        }}
                    />
                }>
                {children}
            </Tooltip>
        );
    } else {
        return children;
    }
};

TooltipDisableSortableItem.propTypes = {
    activeFilter: PropTypes.object,
    children: PropTypes.node,
    resetFilters: PropTypes.func
};
